import React from 'react';
import styled from 'styled-components'
import logo from '@/assets/common/logo.svg'
import NormalLink from '@/components/core/NormalLink'
import Header from '@/components/core/Header';
import device from '../lp/device';

export interface BeforeSignInTemplateProps {
    
}

const BeforeSignInTemplate: React.FC<BeforeSignInTemplateProps> = (props) => {
    return (
        <>
            <HeaderArea>
                <Header subContents={
                    <HeaderButton>
                        <NormalLink data-link-signup to="/auth/signup">アカウント登録（無料）</NormalLink>
                        <NormalLink data-link-signin to="/auth/signin">ログイン</NormalLink>
                    </HeaderButton>
                } />
            </HeaderArea>
            <Main>
                {
                props.children
                }
            </Main>
        </>
    )
}

export default BeforeSignInTemplate;


const HeaderArea = styled.header`
    display: flex;
    height: 65px;
    align-items: center;
`

const HeaderButton = styled.header`
    display: flex;
    justify-content: space-around;
    width: 240px;
    margin: auto 20px;

    @media ${device.mobile} {
        margin: auto 0;
        justify-content: flex-end;
    }

    & > a {
        @media ${device.mobile} {
            padding: 0 6px;
            font-size: 10px;
            margin: auto 2px;
        }
    }
`



const Main = styled.main`
    height: calc(100vh - 100px);
`